<template>
  <Modal
  :id="'cmp-dt-add-task'" 
    @cancelled="onCancel"
  >
    <template slot="header">Add Task</template>

    <template slot="body">
        <TextField
          class="m1"
          :id="'task'"
          v-bind="textFieldConfig"
          :value="task.task"
          :placeholder="$t('task')"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          :options="usersTV"
          class="m2"
          :selected="assignedUserSelectedTV"
          :placeholder="$t('assigned_user')"
          v-on:selectedChange="e => onDropdownChange('assigned_users', e)"
          :listHeight="120"
          box
          multiple
        />
        <TextField
          type="date"
          id="due_date"
          class="m1"
          :placeholder="$t('due_date')"
          :value="task.due_date"
          @valuechanged="onTextFieldValueChange"
        />

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onTaskTemplateSubmit">
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { taskService } from "../../modules/tasks/services/tasks.service";


export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      task:  {
        task: "",
        due_date: "",
        assigned_users: "",
        sent_user: "",
        status: "open",
        external_table:"general"
      },
      formData: {}
    };
  },
  mounted: async function() {
    const formData = await taskService.tasksTab();
    this.formData = formData.data;
    console.log("POIUUYJHG",this.formData)
  },
  computed: {
    usersTV(){
      return (this.formData?.users || []).map(r => ({text: r.user_name, value: r.user_id}));
    },
    assignedUserSelectedTV(){
      const assignedUserArr = this.task?.assigned_users ? this.task.assigned_users.split(',') : [];
      return this.usersTV.filter( userTV => assignedUserArr.includes("" + userTV.value) ) || [];
    },
  },
  methods: {
    onTaskTemplateSubmit: function() {
   
      this.$emit("insert", {
       
        ...this.task
      });
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function(id, value) {
      this.task[id] = value;
    },
    onDropdownChange: function(name, value) {
      let val = value.value;
      if(['assigned_users', 'local_detail_type_ids'].includes(name)){
        val = value.map(r => r.value).join();
      }
      this.task[name] = val;

      console.log(this.task[name],"NAME,VALUE",name,val)
    },
    onCheckboxChange: function(name, event) {
      this.task[name] = event.target.checked ? "1" : "0";
    },

  }
};
</script>

<style lang="scss">
.cmp-settings-task-template-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
